export default "__VITE_PUBLIC_ASSET__095c7f36__"